import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from 'assets/images/imageData';
import { Button } from 'react-bootstrap';
import DocumentView from 'components/sales/downloadDocView/documentView';
import {toast} from "react-toastify";

const ViewReportPmSoftwareSites = ({
                               match,
                               pmSoftwareViewReport,
                               pmSoftwareReportDetails=[],
                               pocListBySiteId,
                               pmSoftwareReportRejected,
                               pmSoftwareReportApprove,
                               getPocBySiteId,
                               pmSoftwarePostMail,
                           }) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [rejectMod, setRejectModal] = useState(false);
    const [poclist, setPocList] = useState([]);
    const [showOtherEmail, setShowOtherEmail] = useState(false);
    const [mailList, setMailList] = useState([]);
    const [otherEmail, setOtherEmail] = useState();
    const [modal, setModal] = useState(false);
    const [remark, setRemark] = useState("");
    const [isModal, setIsModal] = useState(false);
    const [mailBody, setMailBody] = useState(
        "The process involves software and flow testing at Site. We are happy to inform you that all systems are working well. Additionally, We would like to take this opportunity to remind you that, as informed earlier, the car lanes should not be used by pedestrians and cyclists to prevent the risk of injury during the normal functioning of the barrier. We recommend our add-on products that complement the system's functioning and provide added safety and security to your home. Few of our offerings are.\n" +
        "1. Traffic cones for demarcation\n" +
        "2. Speed breakers & Rumble strips for traffic speed control\n" +
        "3. Bollards for lane separations\n" +
        "4. Light batons for security guards\n" +
        "5. Signboards for people and traffic management\n" +
        "\n" +
        "Please acknowledge this mail to avoid any confusion. In case of any concerns regarding our offering product then please access the “client order section” under admin dashboard,for any service related issue please access “ Help and support through dashboard.\n")

    const handleModalHide = () => {
        setIsModal(false);
        window.location.reload();
    }

    const generateReport = (val) => {
        if (val) {
            setOpenModal(true);
        }
    };
    const rejectModal = (val) => {
        if (val) {
            setRejectModal(true);
        }
    };
    const handleClose = () => setRejectModal(false);

    useEffect(() => {
        (async () => {
            if (pmSoftwareViewReport) {
                setIsLoading(true);
                await pmSoftwareViewReport(match.params.manageId);
                await getPocBySiteId(match.params.id);
                setIsLoading(false);
            }
        })();
    }, [pmSoftwareViewReport]);

    const rejectPM = (val) => {
        if (val) {
            (async () => {
                if (match.params.manageId) {
                    const res = await pmSoftwareReportRejected({schedule_id:match.params.manageId});
                    if (parseInt(res?.status) === 200) {
                        window.location.reload();
                    }else{
                        toast.error(res.message)
                    }
                }
            })();
        }
    };

    const handleApprove = (val) => {
        if(val) {
            setIsModal(true);
        }
    }

    const handleContinue =  (val) => {
        if(val) {
            setIsModal(false);
            (async () => {
                if (match.params.manageId) {
                    const res= await pmSoftwareReportApprove({schedule_id: match.params.manageId, remark: remark});
                    if (parseInt(res?.status) === 200) {
                        window.location.reload();
                    }else{
                        toast.error(res.message)
                    }
                }
            })();
            setIsLoading(false);
        }
    };

    // const approval = (val) => {
    //   if (val) {
    //     (async () => {
    //     if (match.params.manageId) {
    //       const res = await postApprovePmSite(match.params.manageId);
    //       if (res === true) {
    //         window.location.reload();
    //       }
    //     }
    //     })();
    //   }
    // };

    const sendMailPoc = async () => {
        // const findIndex =
        //   mailList &&
        //   mailList.length > 0 &&
        //   mailList.findIndex((el) => el === 'Others');
        // if (findIndex !== -1) {
        //   mailList.splice(findIndex, 1);
        //   mailList.push(otherEmail);
        //   setMailList([...mailList]);
        // }
        setOpenModal(false)
        setTimeout(async () => {
            const data = {
                schedule_id: match.params.manageId,
                // pocs: mailList
            };
            if (data.post_mail_body !== '') {
                data['post_mail_body'] = mailBody
                setIsLoading(true);
                const res = await pmSoftwarePostMail(data);
                setIsLoading(false);
                if (parseInt(res.status) === 200) {
                    toast.success(res.message)
                }else{
                    toast.error(res.message)
                }
            }else{
                toast.error("Mail body is required");
                return false
            }
        }, 1000);
    };

    useEffect(() => {
        (() => {
            if (
                poclist &&
                poclist.length > 0 &&
                poclist.some((obj) => obj.id === 'Others')
            ) {
                setShowOtherEmail(true);
            } else {
                setShowOtherEmail(false);
            }
        })();
    }, [poclist]);

    // const pmSiteReportDownloads = (val) => {
    //     if (val) {
    //         (async () => {
    //             if (match.params.manageId) {
    //                 const res = await pmSiteReportDownload(match.params.manageId);
    //                 if(res.response.data){
    //                     window.open(res.response.data);
    //                 }else{
    //
    //                 }
    //             }
    //         })();
    //     }
    // };

    useEffect(() => {
        const list =
            poclist && poclist.length > 0 && poclist.map((element) => element['id']);
        setMailList(list);
    }, [poclist]);

    // site_status
    const headerBtns = () => {
        return (
            <Fragment>
                {pmSoftwareReportDetails &&
                    pmSoftwareReportDetails.site_status && parseInt(pmSoftwareReportDetails.site_status) === 4  &&
                    <Button
                        className=" btn btn-danger"
                        onClick={() => rejectModal(true)}
                    >
                        {localization.reject}
                    </Button>
                }
                {pmSoftwareReportDetails &&
                    pmSoftwareReportDetails.site_status && parseInt(pmSoftwareReportDetails.site_status) === 4  &&
                    <Button
                        className=" btn btn-danger"
                        //onClick={() => approval(true)}
                        onClick={() => handleApprove(true)}
                    >
                        {localization.approve}
                    </Button>
                }
                <Button
                    className=" btn btn-primary"
                    onClick={() => generateReport(true)}
                >
                    {localization.notify}
                </Button>
                {/*<Button*/}
                {/*    className=" btn btn-primary"*/}
                {/*    onClick={() => pmSiteReportDownloads(true)}*/}
                {/*>*/}
                {/*    Download*/}
                {/*</Button>*/}
                {/* pmSiteReportDownload */}
            </Fragment>
        );
    };

    const openHideModal = () => setOpenModal(false);
    const emailModalHide = () => setModal(false);

    return (
        <Layout
            title={localization.viewChecklistReport}
            Buttons={headerBtns}
            isLoading={isLoading}
            isGoback
            linkUrl={`${baseUrl}/approvals/pm-sites`}
        >
            {
                pmSoftwareReportDetails &&
                pmSoftwareReportDetails.uploaded_doc &&
                (
                    <DocumentView
                        title={'Uploaded Document'}
                        attachment={pmSoftwareReportDetails.uploaded_doc}
                    />
                )
            }
            <br />
            <div className="panel-card" >
                <div className="panel-heading">Pm Software</div>
                <div className="panel-body">
                    <div className="form-group">
                        <div className="details-listing faq-listing">
                            {pmSoftwareReportDetails && pmSoftwareReportDetails.questions !== undefined && pmSoftwareReportDetails.questions.map((item, index1) => {

                                return (
                                    <div
                                        className="details-list question-input"
                                        key={index1}
                                    >
                                        <label className="data-title">{item.questions}</label>
                                        {item.answers.length &&
                                            item.answers.map((ele, ind) => {
                                                if (
                                                    ele.type.toLowerCase() === 'file' ||
                                                    ele.type_id === 4
                                                ) {
                                                    return (
                                                        <div className="row">
                                                            <div className="">
                                                                {ele && ele.answer && ele.answer.map((val, i) => {
                                                                    return (
                                                                        <>
                                                                            <div className="col-md-12">
                                                                                <img
                                                                                    src={val}
                                                                                    width="100%"
                                                                                    key={i}
                                                                                />
                                                                                <br></br>
                                                                                <br></br>
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    );
                                                } else {
                                                    return (
                                                        <div className="sub-question" key={ind}>
                                                            <label className="label">{ele.label}</label>
                                                            <label className="label">
                                                                {ele.answer}
                                                            </label>
                                                        </div>
                                                    );
                                                }
                                            })}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <ModalPop
                title={localization.notify}
                show={openModal}
                handleModalHide={openHideModal}
                keyboard
                backdrop
            >
                <div className="text-center">
                    {/*<DropDownInput*/}
                    {/*  multipule*/}
                    {/*  label={localization.toName}*/}
                    {/*  data={pocListBySiteId}*/}
                    {/*  required*/}
                    {/*  isStarRequired={true}*/}
                    {/*  errorMsg={localization.isRequired}*/}
                    {/*  getIdValue={(val) => {*/}
                    {/*    setPocList(val);*/}
                    {/*  }}*/}
                    {/*/>*/}
                    {showOtherEmail && (
                        <ConstantInput
                            label={localization.emailAddress}
                            regex={Regex.email.test(otherEmail)}
                            errorMsg={localization.emailError}
                            handleChange={(val) => {
                                setOtherEmail(val);
                            }}
                            type="text"
                        />
                    )}
                    <textarea
                        className="form-control form-control-user cus-red"
                        placeholder="Email Body"
                        onChange={(e) => {
                            setMailBody(e.target.value)
                        }}
                        required
                        rows="12" cols="50"
                        value={mailBody}
                    />
                    <Button
                        className="btn btn-primary mb-4"
                        onClick={() => {
                            sendMailPoc();
                        }}
                    >
                        {localization.submit} <img src={Images?.ArrowRight} alt="" />
                    </Button>
                </div>
            </ModalPop>

            <ModalPop
                title={localization.conf}
                show={modal}
                handleModalHide={emailModalHide}
                keyboard
                backdrop
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>{localization.mailSuccessfully}</h5>
                </div>
            </ModalPop>

            <ModalPop
                title={localization.conf}
                show={rejectMod}
                handleModalHide={openHideModal}
                keyboard
                backdrop
            >
                <div className="text-center">

                    <img src={Images?.alert} alt="" />

                    <h5>Are you sure you want to reject ?</h5>
                    <div className="row">
                        <div className="col-4"></div>
                        <div className="col-2">
                            <Button variant="primary"  onClick={() => {
                                rejectPM(true)
                            }}>
                                Yes
                            </Button>
                        </div>
                        <div className="col-2">
                            <Button variant="secondary" onClick={handleClose}>
                                No
                            </Button>
                        </div>
                    </div>
                </div>
            </ModalPop>
            <ModalPop
                title={`Approve PM`}
                show={isModal}
                handleModalHide={handleModalHide}
            >
                <Fragment>
                    <div className="modal-body">
                        <div className="text-center">
                            {/* <h5>{localization.areYouSure}</h5> */}
                            <div className="form-group">
                                <div className="col-sm-6">
                                    <ConstantInput
                                        label={localization.addRemark}
                                        required
                                        isStarRequired={true}
                                        type="text"
                                        handleChange={(val) => {
                                            setRemark(val);
                                        }}
                                    />
                                </div>
                            </div>
                            <Button
                                className="btn btn-primary"
                                onClick={() => handleContinue(true)}
                                //disabled={!remark}
                            >
                                {localization.continue}{' '}
                                <img src="../images/arrow-right.png" alt="" />
                            </Button>
                        </div>
                    </div>
                </Fragment>
            </ModalPop>
        </Layout>
    );
};

export default ViewReportPmSoftwareSites;
